import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformToolBucketFolderViewComponent} from '@features/transaction-tracker/components/platform-tool-bucket-folder-view/platform-tool-bucket-folder-view.component';

// @dynamic
export class TransactionTrackerDynamicComponentHelper {
  public static components: any;
  public static init() {
    if (TransactionTrackerDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['PlatformToolBucketFolderViewComponent'] = PlatformToolBucketFolderViewComponent;
    TransactionTrackerDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static getComponentArray(): any[] {
    TransactionTrackerDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(TransactionTrackerDynamicComponentHelper.components).forEach(key => {
      componentArray.push(TransactionTrackerDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
  public static register(key: string, component: any) {
    TransactionTrackerDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
